const removeClassByPrefix = (node: HTMLElement, prefix: string): HTMLElement => {
    const regex = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regex, '');
    return node;
};

export default removeClassByPrefix;
